// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--2d913";
export var layout = "Footer-module--layout--17146";
export var top = "Footer-module--top--7365c";
export var contacts = "Footer-module--contacts--01560";
export var navigation = "Footer-module--navigation--6d64c";
export var link = "Footer-module--link--e0d8f";
export var copyright = "Footer-module--copyright--a775b";
export var captchaText = "Footer-module--captchaText--d5e7d";